import "./styles.css";

function BackgroundLanding() {
  return (
    <>
      <div className="snake-background landing-snake-upper"></div>
      <div className="snake-background landing-snake-footer"></div>
    </>
  );
}

function BackgroundAbout() {
  return (
    <>
      <div className="snake-background about-snake-upper"></div>
      <div className="snake-background about-snake-footer"></div>
    </>
  );
}

function BackgroundContact() {
  return (
    <>
      <div className="snake-background contact-snake-upper"></div>
    </>
  );
}

function BackgroundPolicy() {
  return (
    <>
      <div className="snake-background about-snake-upper"></div>
      <div className="snake-background about-snake-footer"></div>
    </>
  );
}

export { BackgroundLanding, BackgroundAbout, BackgroundContact, BackgroundPolicy };
